import { ThemeEvents } from '@theme/events';
import { formatMoney } from '@theme/money-formatting';

class HomeFloatingCart extends HTMLElement {
  connectedCallback() {
    this.countElement = this.querySelector('[data-home-floating-cart-count]');
    this.totalElement = this.querySelector('[data-home-floating-cart-total]');
    this.trigger = this.querySelector('[data-home-floating-cart-trigger]');
    this.moneyFormat = this.dataset.moneyFormat || '{{amount}}';
    this.currency = this.dataset.currency || 'USD';

    document.addEventListener(ThemeEvents.cartUpdate, this.handleCartUpdate);
    window.addEventListener('pageshow', this.handlePageShow);
    this.trigger?.addEventListener('click', this.handleTriggerClick);
  }

  disconnectedCallback() {
    document.removeEventListener(ThemeEvents.cartUpdate, this.handleCartUpdate);
    window.removeEventListener('pageshow', this.handlePageShow);
    this.trigger?.removeEventListener('click', this.handleTriggerClick);
  }

  handleCartUpdate = (event) => {
    const cart = event.detail?.resource;

    if (typeof cart?.item_count === 'number' && typeof cart?.total_price === 'number') {
      this.renderCart(cart);
      return;
    }

    this.refreshCart();
  };

  handlePageShow = (event) => {
    if (event.persisted) {
      this.refreshCart();
    }
  };

  handleTriggerClick = () => {
    const drawerTrigger = document.querySelector('[data-testid="cart-drawer-trigger"]');

    if (drawerTrigger instanceof HTMLElement) {
      drawerTrigger.click();
      return;
    }

    window.location.href = Theme.routes.cart_url;
  };

  async refreshCart() {
    try {
      const response = await fetch(`${Theme.routes.cart_url}.js`);
      const cart = await response.json();

      this.renderCart(cart);
    } catch (error) {
      console.error('Failed to refresh floating cart:', error);
    }
  }

  renderCart(cart) {
    const itemCount = Number(cart.item_count) || 0;
    const totalPrice = Number(cart.total_price) || 0;
    const currency = typeof cart.currency === 'string' ? cart.currency : cart.currency?.iso_code || this.currency;
    const countText = `${itemCount} ${itemCount === 1 ? 'Item' : 'Items'}`;
    const totalText = formatMoney(totalPrice, this.moneyFormat, currency);

    if (this.countElement) {
      this.countElement.textContent = countText;
    }

    if (this.totalElement) {
      this.totalElement.textContent = totalText;
    }

    const control = this.querySelector('.home-floating-cart__link');
    control?.setAttribute('aria-label', `Cart: ${countText}, ${totalText}`);
  }
}

if (!customElements.get('home-floating-cart')) {
  customElements.define('home-floating-cart', HomeFloatingCart);
}
